import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const DEFAULT_PAGE_SIZE = 50

interface PageSizeState {
	pageSize: number
	setPageSize: (next: number) => void
}

/**
 * Global rows-per-page preference shared by every server-driven list.
 * Persisted to localStorage so the choice survives reloads and syncs
 * across tabs via the `storage` event.
 *
 * Zustand + `persist` middleware handles hydration, serialization, and
 * cross-tab sync for us — avoids the boilerplate of reading/writing
 * `localStorage` and wiring `storage` event listeners by hand.
 */
export const usePageSize = create<PageSizeState>()(
	persist(
		(set) => ({
			pageSize: DEFAULT_PAGE_SIZE,
			setPageSize: (pageSize) => set({ pageSize })
		}),
		{ name: 'page-size' }
	)
)
